export const SUBSCRIPTION_CHECKOUT_ENTRY_PARAM = 'subscription_checkout_entry';
export const SUBSCRIPTION_CHECKOUT_ENTRY_VALUE = 'personal_plan_landing_page';

const appendSubscriptionCheckoutEntry = (queryString: string): string => {
    const params = new URLSearchParams(queryString.replace(/^\?/, ''));
    params.set(SUBSCRIPTION_CHECKOUT_ENTRY_PARAM, SUBSCRIPTION_CHECKOUT_ENTRY_VALUE);
    return params.toString();
};

export const PERSONAL_PLAN_CHECKOUT_URL = `/subscription-checkout/express/?${appendSubscriptionCheckoutEntry(
    'product_type=CONSUMERSUBSCRIPTION&plan_preference=YEAR',
)}`;

export const PERSONAL_PLAN_UPGRADE_URL = `/subscription-checkout/upgrade/?${appendSubscriptionCheckoutEntry(
    'upgrade_type=tier&product_type=CONSUMERSUBSCRIPTION',
)}`;
